import { DialogType } from '../../../@types';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import useFilterForm from '../../../hooks/useFilterForm';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import FormSelect from '../../molecules/FormSelect';
import ValidityPeriodSelect from '../../molecules/ValidityPeriodSelect';
import PartnerSelect from '../../molecules/PartnerSelect';
import {
  AFFILIATE_CAMPAIGN_PRODUCT_OPTIONS,
  AFFILIATE_CAMPAIGN_STATUS_OPTIONS,
  AFFILIATE_CAMPAIGN_TYPE_OPTIONS,
} from '../../../constants';
import type {
  AffiliateCampaignType,
  AffiliateCampaignStatus,
  AffiliateCampaignProduct,
  ValidityPeriod,
} from '../../../@types/api';
import { USER_ROLES } from '../../../constants/keycloak';
import { VALIDITY_PERIOD } from '../../../constants/enums';
import usePermissions from '../../../hooks/usePermissions';

type FilterCampaignReportsData = {
  agentId?: string;
  type?: AffiliateCampaignType;
  product?: AffiliateCampaignProduct;
  status?: AffiliateCampaignStatus;
  validityPeriod?: ValidityPeriod;
};

const defaultValues: FilterCampaignReportsData = {
  agentId: undefined,
  type: undefined,
  product: undefined,
  status: undefined,
  validityPeriod: VALIDITY_PERIOD.ONGOING,
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterCampaignReports = ({ closeModal, changeQuery }: Props) => {
  const { isAffiliate } = usePermissions();
  const { control, handleSubmit, handleResetFilter } = useFilterForm<FilterCampaignReportsData>({
    defaultData: defaultValues,
    changeQuery,
  });

  const handleClose = () => {
    closeModal?.();
  };

  const showAffiliateSelect = !isAffiliate;

  return (
    <FilterDialogLayout
      label='campaign reports'
      onClose={handleClose}
      onSave={handleSubmit}
      onReset={handleResetFilter}
    >
      {showAffiliateSelect && (
        <PartnerSelect
          name='agentId'
          control={control}
          label='Affiliate'
          multipleSelect={false}
          queryParams={{
            roleTypes: [USER_ROLES.AFFILIATE],
          }}
        />
      )}
      <FormSelect control={control} name='status' label='Status' options={AFFILIATE_CAMPAIGN_STATUS_OPTIONS} />
      <FormSelect control={control} name='type' label='Campaign Type' options={AFFILIATE_CAMPAIGN_TYPE_OPTIONS} />
      <FormSelect control={control} name='product' label='Product' options={AFFILIATE_CAMPAIGN_PRODUCT_OPTIONS} />
      <ValidityPeriodSelect control={control} disabled />
    </FilterDialogLayout>
  );
};

export default FilterCampaignReports;
